<template>
  <div class="container-fluid py-4">

    <div class="row mb-4">
      <router-link
        class="btn btn-default m-2"
        :to="{ name: 'cat-terminal-pos', params: {} }"
      >
        <i class="fas fa-arrow-left"></i>
        Volver al Listado
      </router-link>
      <div class="col-12">
        <div class="d-flex justify-content-between position-relative align-items-center"
          style="max-width: 500px; margin: 0 auto;">
          <div class="position-absolute bg-light w-100" style="height: 2px; top: 50%; left: 0; z-index: 1;"></div>
          <div class="text-center position-relative" style="z-index: 2;">
            <div
              :class="['rounded-circle d-flex align-items-center justify-content-center border', pasoActual >= 1 ? 'bg-success text-white border-success' : 'bg-white text-muted']"
              style="width: 35px; height: 35px; font-weight: 600;">
              1
            </div>
            <span class="small text-muted d-block mt-1">Ubicación</span>
          </div>

          <div class="text-center position-relative" style="z-index: 2;">
            <div
              :class="['rounded-circle d-flex align-items-center justify-content-center border', pasoActual === 2 ? 'bg-success text-white border-success' : 'bg-white text-muted']"
              style="width: 35px; height: 35px; font-weight: 600;">
              2
            </div>
            <span class="small text-muted d-block mt-1">Datos Terminal</span>
          </div>

        </div>
      </div>
    </div>

    <hr class="mb-4">

    <div v-if="pasoActual === 1" class="row justify-content-center">
      <div class="col-md-6">
        <div class="card shadow-sm border-0">
          <div class="card-body p-4">
            <h5 class="text-secondary font-weight-normal mb-3">Asignar Ubicación</h5>
            <p class="text-muted small">Selecciona la sucursal o tienda donde operará físicamente este nuevo
              dispositivo.</p>

            <div class="form-group mb-4">
              <label class="text-muted small font-weight-bold">Tienda / Sucursal</label>
              <select class="form-control text-secondary" v-model="tiendaSeleccionada" @change="obtenerAfiliaciones()">
                <option v-for="tienda in listadoTiendas" :key="tienda.codigo" :value="tienda">
                  {{ tienda.nombre }}
                </option>
              </select>
            </div>
            
            <div class="form-group mb-4" v-if="isTiendaSelected">
              <label class="text-muted small font-weight-bold">Afiliación de Tienda</label>
              <select class="form-control text-secondary" v-model="afiliacionSeleccionada">
                <option v-for="afiliacion in afiliaciones" :key="afiliacion.id" :value="afiliacion.id">
                  {{ afiliacion.numero_afiliado }} - {{ afiliacion.proveedor }} | Principal: {{ sino(afiliacion.principal) }}
                </option>
              </select>
            </div>
            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-sm btn-success px-4" v-if="isTiendaSelected && isAfiliacionSelected"
                @click="siguientePaso">
                Siguiente <i class="fa fa-arrow-right ml-1"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="pasoActual === 2" class="row justify-content-center">
      <div class="col-md-10">
        <div class="card shadow-sm border-0">
          <div class="card-body p-4">
            <h5 class="text-secondary font-weight-normal mb-4">Especificaciones técnicas de la Terminal</h5>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="text-muted small font-weight-bold">ID Terminal / Código</label>
                  <input type="text" 
                    :class="{
                      'form-control text-secondary border-success':isTerminalIDValid,
                      'form-control text-secondary border-danger':!isTerminalIDValid,
                     }" 
                    v-model="nuevaTerminal.terminal_id"
                    placeholder="Ej. TRM-092"
                  >
                </div>

                <div class="form-group mb-3">
                  <label class="text-muted small font-weight-bold">Modelo</label>
                  <input type="text" class="form-control text-secondary" v-model="nuevaTerminal.modelo"
                    placeholder="Ej. PAX A77">
                </div>

                <div class="form-group mb-3">
                  <label class="text-muted small font-weight-bold">IMEI</label>
                  <input type="text" class="form-control text-secondary" v-model="nuevaTerminal.imei"
                    placeholder="Ingrese el IMEI">
                </div>

                <div class="form-group mb-3">
                  <label class="text-muted small font-weight-bold">Número de Serie</label>
                  <input type="text" 
                    :class="{
                      'form-control text-secondary border-success':isNumeroSerieValid,
                      'form-control text-secondary border-danger':!isNumeroSerieValid,
                     }"
                    v-model="nuevaTerminal.numero_serie"
                    placeholder="Ingrese número de serie"
                  >
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="text-muted small font-weight-bold">Tipo POS</label>
                  <select 
                    :class="{
                      'form-control text-secondary border-success':isTipoPOSValid,
                      'form-control text-secondary border-danger':!isTipoPOSValid,
                     }"
                    v-model="nuevaTerminal.tipo_pos">
                    <option
                      v-for="tipo in tipos_pos"
                      :key="tipo.llave"
                      :value="tipo.llave"
                    >{{ tipo.valor }}</option>
                  </select>
                </div>

                <div class="form-group mb-3">
                  <label class="text-muted small font-weight-bold">Tipo de Cobro</label>
                  <select 
                    :class="{
                      'form-control text-secondary border-success':isTipCobroValid,
                      'form-control text-secondary border-danger':!isTipCobroValid,
                     }" 
                    v-model="nuevaTerminal.tipos_cobro">
                    <option 
                      v-for="tipo in tipos_cobro"
                      :key="tipo.llave"
                      :value="tipo.llave"
                    >{{ tipo.valor }}</option>
                  </select>
                </div>

                <div class="form-group mb-3">
                  <label class="text-muted small font-weight-bold">Dirección IP</label>
                  <input type="text" class="form-control text-secondary" v-model="nuevaTerminal.ip"
                    placeholder="Ej. 192.168.1.50">
                </div>

              </div>
            </div>

            <div class="d-flex justify-content-between mt-4 pt-3 border-top">
              <button type="button" class="btn btn-sm btn-outline-secondary px-3" @click="atrasPaso">
                <i class="fa fa-arrow-left mr-1"></i> Regresar
              </button>
              <button type="button" class="btn btn-sm btn-success px-4"
                @click="guardarNuevaTerminal">
                <i class="fa fa-save mr-1"></i> Guardar Terminal
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import TerminalPOSService from "@/services/catalogos/TerminalPOSService";
import DynamicService from "@/services/commons/DynamicService";
export default {
  data() {
    return {
      // Estado para controlar el flujo de pantallas ocultas
      pasoActual: 1,

      // Listado simulado para el paso 1
      listadoTiendas: [],

      tipos_cobro:[],
      tipos_pos:[],
      tiendaSeleccionada:null,
      afiliacionSeleccionada: null,
      afiliaciones: [],
      // Objeto único que acumula toda la información recopilada del flujo entero
      nuevaTerminal: {
        terminal_id: null,
        modelo: null,
        imei: null,
        numero_serie: null,
        tipo_pos: null,
        tipos_cobro: null,
        ip: null,
        afiliacion_tienda: null,
      }
    };
  },
  computed: {
    isTiendaSelected(){
      return this.tiendaSeleccionada !== null;
    },
    isAfiliacionSelected(){
      return this.afiliacionSeleccionada!== null;
    },
    // Validación de campos requeridos antes de guardar en el paso final
    isTerminalIDValid() {
      const val = this.nuevaTerminal.terminal_id;
      return val !== null && val !== undefined && String(val).trim() !== '';
    },
    isNumeroSerieValid() {
      const val = this.nuevaTerminal.numero_serie;
      return val !== null && val !== undefined && String(val).trim() !== '';
    },
    isTipoPOSValid() {
      // Ideal para los selectores que inician en null
      return this.nuevaTerminal.tipo_pos !== null && this.nuevaTerminal.tipo_pos !== '';
    },
    isTipCobroValid() {
      return this.nuevaTerminal.tipos_cobro !== null && this.nuevaTerminal.tipos_cobro !== '';
    },
    // Tu validación final ahora limpia y directa
    validacionFormulario() {
      return this.isTerminalIDValid && 
            this.isNumeroSerieValid && 
            this.isTipoPOSValid && 
            this.isTipCobroValid;
    }
  },
  mounted(){
    this.refreshTiendas();
  },
  methods: {
    limpiarDatos(){
      this.nuevaTerminal.terminal_id=null
      this.nuevaTerminal.modelo=null
      this.nuevaTerminal.imei=null
      this.nuevaTerminal.numero_serie=null
      this.nuevaTerminal.tipo_pos=null
      this.nuevaTerminal.tipos_cobro=null
      this.nuevaTerminal.ip=null
      this.nuevaTerminal.afiliacion_tienda=null
      this.tiendaSeleccionada = null;
      this.afiliacionSeleccionada = null;
      this.afiliaciones = [];
      this.tipos_cobro = [];
      this.tipos_pos = [];
      this.listadoTiendas = [];
    },
    sino(valor) {
      return valor ? 'Sí' : 'No';
    },
    siguientePaso() {
      this.obtenerTiposCobro();
      this.obtenerTiposPOS();
      if (this.pasoActual < 2) {
        this.pasoActual++;
      }
    },
    atrasPaso() {
      this.limpiarDatos();
      this.refreshTiendas();

      if (this.pasoActual > 1) {
        this.pasoActual--;
      }
    },
    guardarNuevaTerminal() {
      if (!this.validacionFormulario){
        this.$toast.error("Debe llenar los campos marcados en rojo.", "Error", {
          position: 'topRight'
        });
        return;
      }
      this.nuevaTerminal.afiliacion_tienda = String(this.afiliacionSeleccionada).replaceAll('-', '');
      // payload unificado listo con la tienda elegida en el paso 1 + los datos del paso 2
      const payloadCompleto = { ...this.nuevaTerminal };

      TerminalPOSService.save(payloadCompleto)
      .then(response => {
        this.limpiarDatos();
        this.refreshTiendas();
        this.$toast.success( "Terminal guardada correctamente.","Éxito", {
          position: 'topRight'
        });
        this.$router.push({ name: 'cat-terminal-pos-editar', params: { id: response.data.id } });
      })

      this.reiniciarAsistente();
    },
    reiniciarAsistente() {
      this.pasoActual = 1;
      this.nuevaTerminal = {
        tienda_id: null,
        terminal_id: null,
        modelo: null,
        imei: null,
        numero_serie: null,
        tipo_pos: null,
        tipos_cobro: null,
        ip: null,
        afiliacion_tienda: null,
      };
    },
    obtenerTiposCobro() {
      TerminalPOSService.obtenerTiposCobro()
       .then(response => {
        this.tipos_cobro = response.data;
      });
    },
    obtenerTiposPOS(){
      TerminalPOSService.obtenerTiposPOS()
       .then(response => {
          this.tipos_pos = response.data;
        });
    },
    refreshTiendas(){
      let self = this;
      DynamicService.getActionList("cxc","corte-caja-tienda","lista_tiendas")
      .then(response =>{
        self.listadoTiendas = response.data;
        const hayTiendas = self.listadoTiendas.length > 0;
        
        if(!hayTiendas){
          self.$toast.error("No está asignado a ninguna tienda.","Error",{position: 'topRight'});
          return;
        }
      })
      .catch(error => {
        console.error(error);
        self.$toast.error(JSON.stringify(error.response.data),"Error",{position: 'topRight'});
      });
    },
    obtenerAfiliaciones(){
      let params = {
        tienda:this.tiendaSeleccionada.codigo
      }
      TerminalPOSService.obtenerAfiliacionesTienda(params)
      .then(response => {
        this.afiliaciones = response.data;
      });
    },
  }
}
</script>